import React from 'react';
import { MaintenanceEntitySection } from './MaintenanceEntitySection';

const SupervisorMaintenance = () => (
  <div className="space-y-6 max-w-6xl">
    <div>
      <h2 className="text-xl font-semibold text-gray-900">Supervisor maintenance</h2>
     
    </div>
    <MaintenanceEntitySection
      apiType="Supervisor"
      addTitle="Add supervisor"
      valueLabel="Supervisor name (value)"
      valuePlaceholder="e.g. John Smith"
      codePlaceholder="Optional — defaults to name"
      listHeading="Supervisors"
      emptyHint="No supervisors yet. Use the form on the left."
      deleteModalLabel="supervisor"
    />
  </div>
);

export default SupervisorMaintenance;
